<template>
  <div>
    <el-container style="height:100vh; border: 1px solid #eee">
      <el-aside width="200px;height:100vh;">
        <div>
          <LabelHeader msg="配置分类"></LabelHeader>
          <div class="buttons">
            <el-button @click="expandAll" size="mini" type="primary" style="width: 40%">展开</el-button>
            <el-button @click="foldAll" size="mini" type="warning" style="width: 40%">收起</el-button>
          </div>
          <div class="left">
            <el-tree :data="treeData" ref="menu" @node-click="go" node-key="id" :highlight-current="true" v-if="elTrees" :default-expand-all="expandAlls"/>
          </div>
        </div>
      </el-aside>

      <el-main style="padding: 0px 5px;">

        <LabelHeader msg="配置管理"></LabelHeader>
        <div style="padding-left: 50px">
          <el-form class="searchForm" :inline="true">
            <el-form-item label="名称：">
              <el-input size="small" style="width: 200px" class="ML-10" type="text" v-model="nameText" placeholder="输入名称" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="list()" icon="el-icon-search" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <LabelHeader msg="查询结果"></LabelHeader>
        <div class="buttonBox">
          <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="addTeam()">新增</el-button>
          <el-button type="warning" size="mini" icon="el-icon-edit" @click="updateBindParam()">编辑</el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="remove()">删除</el-button>
        </div>
        <div class="table-box">
          <el-table
                  :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
                  :data="datas"
                  border
                  stripe
                  show-checkbox
                  @selection-change="handleSelectionChange"
          >
            <af-table-column :width="40" type="selection" align="center"></af-table-column>
            <af-table-column prop="name" label="名称"> </af-table-column>
            <af-table-column prop="key" label="编码"> </af-table-column>
            <af-table-column prop="value" label="配置值"> </af-table-column>
            <af-table-column prop="text" label="描述"> </af-table-column>
          </el-table>
        </div>
        <el-dialog v-dialogDrag :title="dialogTitle" v-if="OpenName" :visible.sync="OpenName" :modal="false" width="900px">
          <Edit :params="editParam" @close="close" @success="success"></Edit>
        </el-dialog>
        <div class="paginationBox" v-if="pagination.total > 0">
          <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  :page-sizes="[10, 20, 50, 100]"
                  :total="pagination.total"
                  @size-change="sizeChange"
                  @current-change="currentChange"
          ></el-pagination>
          <el-button class="refreshBtn" circle @click="list" :icon="refreshing ? 'el-icon-refresh refAnimation' : 'el-icon-refresh'"> </el-button>
        </div>
      </el-main>
    </el-container>
  </div>
</template>


<script>
  import LabelHeader from "../../components/LabelHeader";
import Edit from './edit';
export default {
  data() {
    return {
      split: 0.15,
      dialogTitle: '',
      datas: [],
      homeData: [{ title: '配置管理' }],
      byId: null,
      configId: null,
      nameText: '',
      OpenName: false,
      refreshing: false,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      param: {
        keyName: 'id',
        parentName: 'pid',
        titleName: 'name',
        dataMode: 'tree',
        datas: []
      },
      rows: [],
      editParam: {
        id: '',
        tree: []
      },
      elTrees: true,
      expandAlls: false,
      treeData: []
    };
  },
  components: {
    Edit,LabelHeader
  },
  // 页面加载获取数据
  mounted() {
    this.tree();
  },
  methods: {
    refresh() {
      this.list();
      this.tree();
    },
    expandAll() {
      this.elTrees = false;
      this.expandAlls = true;
      this.$nextTick(() => {
        this.elTrees = true;
      });
    },
    foldAll() {
      this.elTrees = false;
      this.expandAlls = false;
      this.$nextTick(() => {
        this.elTrees = true;
      });
    },
    sizeChange(size) {
      this.pagination.pageSize = size;
      this.list();
    },
    currentChange(pageNo) {
      this.pagination.pageNo = pageNo;
      this.list();
    },
    close() {
      this.OpenName = false;
    },
    // from表单
    handleSelectionChange(row) {
      this.rows = row;
    },
    success() {
      this.OpenName = false;
      this.list();
    },
    tree() {
      httpKit.post($api_eap.config.tree).then(res => {
        if (res.data.code === '200') {
          if (res.data.data.length > 0) {
            this.treeData = res.data.data;
            treeFor(this.treeData, 'name');
            this.configId = res.data.data[0].id;
            this.list();
            this.editParam.teamName = res.data.data[0].name;
            this.editParam.teamId = res.data.data[0].id;
          }
        }
      });
    },
    updateBindParam() {
      if (checkSelect(this.rows)) {
        this.dialogTitle = '编辑配置';
        this.OpenName = true;
        this.editParam.id = this.rows[0].id;
        this.editParam.tree = this.treeData;
      }
    },
    addTeam() {
      this.dialogTitle = '新增配置';
      this.OpenName = true;
      this.editParam.id = null;
    },
    remove() {
      deleteArr(this.rows, $api_eap.config.delete, this.refresh);
    },
    go(value) {
      this.configId = value.id;
      this.editParam.teamName = value.name;
      this.editParam.teamId = value.id;
      this.pagination.pageNo = 1;
      this.pagination.pageSize = 10;
      this.list();
    },
    list() {
      this.pagination.teamId = this.configId;
      this.pagination.name = this.nameText;
      this.refreshing = true;
      httpKit.post($api_eap.config.list, this.pagination).then(res => {
        this.refreshing = false;
        if (res.data.code === '200') {
          this.datas = res.data.data;
          this.pagination.total = +res.data.totalItems;
        } else {
          if (res.data.code === '500') {
            this.datas = [];
          }
        }
      });
    }
  }
};
</script>
<style lang="less">
.el-tree-node.is-current > .el-tree-node__content {
  background-color: #2f8dfb !important;
  color: white;
}
.left {
  max-height: calc(100vh - 230px);
  overflow-y: auto;
}
</style>
